export const GROUP_DATE_FORMAT = 'D MMMM';
